export function getFileNameFromURL(url: string) {
  const filenameURL = new URL(url);
  const fileName = filenameURL.pathname.replace(/^.*[\\/]/, '');

  return fileName;
}
